import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import styles from './map.css';

const Marker = ({ text }) => ( <div className={styles.marker}>
  {text}
</div>
);

export default class Map extends Component {
  static defaultProps = {
    center: {lat: 54.44, lng: 18.57},
    zoom: 15
  };

  render() {
    return (
      <div style={{height: '50vh', width: '65vh', border: '100%'}}>
       <GoogleMapReact
        defaultCenter={this.props.center}
        defaultZoom={this.props.zoom}
      >
        <Marker 
          lat={54.4417242} 
          lng={18.5687533} 
          text={'Osaka'} 
        />
      </GoogleMapReact>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Map/Map.js